import React, { createContext, Dispatch, ReactNode, useReducer } from "react";
import { DetailsListColumn } from "./types";

export const ResizeContext = createContext<[ResizeState, Dispatch<any>]>(
  [] as any
);

type Props = {
  children: ReactNode;
};

type ResizeState = {
  isResizing: boolean;
  column: DetailsListColumn | null;
  columnIndex: number | null;
  startMouseX: number;
  mouseX: number;
  canResize: boolean;
};

const initialState: ResizeState = {
  isResizing: false,
  column: null,
  columnIndex: null,
  startMouseX: 0,
  mouseX: 0,
  canResize: false
};

const getCanResize = ({
  x1,
  x2,
  width
}: {
  x1: number;
  x2: number;
  width: number;
}) => {
  const deltaX = x2 - x1;
  const newWidth = width + deltaX;
  const canResize = newWidth >= 20;
  return canResize;
};

export const ResizeContextProvider = ({ children }: Props) => {
  const reducerResult = useReducer((s: ResizeState, a: any) => {
    switch (a.type) {
      case "START_RESIZE": {
        const { column, columnIndex, mouseX } = a.payload;

        return {
          ...s,
          isResizing: true,
          column,
          columnIndex,
          startMouseX: mouseX,
          mouseX,
          canResize: getCanResize({
            x1: mouseX,
            x2: mouseX,
            width: column.width
          })
        };
      }
      case "RESIZE": {
        const { mouseX } = a.payload;
        if (!s.column) return s;
        return {
          ...s,
          mouseX,
          canResize: getCanResize({
            x1: s.startMouseX,
            x2: mouseX,
            width: s.column.width
          })
        };
      }
      case "END_RESIZE": {
        return initialState;
      }
      default: {
        return s;
      }
    }
  }, initialState);

  return (
    <ResizeContext.Provider value={reducerResult}>
      {children}
    </ResizeContext.Provider>
  );
};
